import { TriggerExpand } from './TriggerExpand';

export default TriggerExpand;
